import React, { Component } from "react";
import { Button, Checkbox, Grid, Typography } from "@material-ui/core";
import { connect } from "react-redux";
import { primaryColor, webFont } from "../../config/theme";
import { compose, graphql } from "react-apollo";
import { UPDATE } from "../../graphql/mutations/user";
import { client } from "../../config/apollo";
import { GET_USER } from "../../graphql/queries/user";
import { UPDATE_IN_PROGRESS_BOOKING } from "../../graphql/mutations/booking";
import { CreateInProgressBooking } from "../../redux/bookings";

class InProgress2 extends Component {
  state = {
    equipment: [],
    selectedEquip: []
  };

  componentDidMount() {
    const { userId } = this.props;
    client
      .query({
        query: GET_USER,
        variables: {
          id: userId
        },
        fetchPolicy: "network-only"
      })
      .then(result => {
        if (result.data.user) {
          this.setState({ equipment: result.data.user.equipments });
        }
      })
      .catch(err => {
        console.log(JSON.parse(JSON.stringify(err)));
      });
  }

  handleChange = (equi, checked) => {
    let { selectedEquip } = this.state;
    if (checked) {
      selectedEquip.push(equi);
    } else {
      let index = selectedEquip.indexOf(equi);
      selectedEquip.splice(index, 1);
    }
    this.setState({ selectedEquip: selectedEquip });
  };

  updateInProgressBooking = () => {
    const {
      cart,
      updateInProgressBooking,
      dispatch,
      inProgressBooking
    } = this.props;
    let dishes = [];
    cart.map(dish => {
      let bookingDish = {
        dishId: dish.id,
        serves: dish.serves
      };
      dishes.push(bookingDish);
    });

    const { selectedEquip } = this.state;

    let payload = {
      userId: this.props.userId,
      chefId: this.props.selectedChefId || this.props.chef.id,
      distance: "10",
      dishes: dishes
    };

    if (selectedEquip.length > 0) {
      payload.equipmentsPresent = selectedEquip;
    }

    updateInProgressBooking({
      variables: {
        bookingId: inProgressBooking,
        booking: payload
      }
    })
      .then(res => {
        console.log(res.data);
      })
      .catch(err => {
        console.log(JSON.parse(JSON.stringify(err)));
      });
  };

  render() {
    const { equipment } = this.state;
    return (
      <div>
        <Grid container>
          <Grid item xs={12}>
            <Typography
              style={{
                ...styles.setFont,
                fontSize: 24,
                fontWeight: 500,
                marginBottom: 30,
                color: '#000'
              }}
            >
              My kitchen
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography
              style={{ ...styles.setFont, fontSize: 16, marginBottom: 20, fontWeight: 500 }}
            >
              Let the chef know what equipment you have
            </Typography>
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={12}>
            {equipment.map(equi => {
              return (
                <div>
                  <Grid container>
                    <Grid

                    data-test-id={"kitcheneqip"}

                      item
                      xs={9}
                      style={{
                        ...styles.setFont,
                        fontSize: 18,
                        marginBottom: 18
                      }}
                    >
                      {equi}
                    </Grid>
                    <Grid

                    data-test-id={"equipcheck"}

                    item xs={3}>
                      <Checkbox
                        onChange={(e, checked) => {
                          this.handleChange(equi, checked);
                        }}
                      />
                    </Grid>
                  </Grid>
                </div>
              );
            })}
            {equipment.length <= 0 && <p>
              <span style={{ ...styles.setFont, fontSize: 14, fontWeight: 400 }}>
                You can optionally specify what equipments your kitchen has through your Profile settings.
              </span>

            </p>}
          </Grid>
        </Grid>

        <Grid container alignItems="center" alignContent="center" justify="center" style={{marginTop: 40}}>
          <Button

        data-test-id={"bkgtwonext"}

            style={{ ...styles.setFont, ...styles.nextBtn }}
            onClick={() => {
              this.props.changeProgressStep(4);
              this.updateInProgressBooking();
            }}
          >
            Next
          </Button>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    userId: state.auth.userId,
    cart: state.bookings.cart,
    isChef: state.auth.isChef,
    selectedChefId: state.bookings.selectedChefId,
    inProgressBooking: state.bookings.inProgressBooking,
    selectedSlot: state.bookings.selectedSlot
  };
};

const InProgressWithData = compose(
  graphql(UPDATE, { name: "updateUser" }),
  graphql(UPDATE_IN_PROGRESS_BOOKING, { name: "updateInProgressBooking" })
)(InProgress2);

const InProgressTwo = connect(mapStateToProps)(InProgressWithData);
export default InProgressTwo;

const styles = {
  setFont: {
    fontFamily: webFont
  },
  error: { fontSize: 12, color: "red", fontFamily: webFont },
  nextBtn: {
    minWidth: 240,
    textAlign: "center",
    borderRadius: 24,
    backgroundColor: primaryColor,
    color: "#fff",
    textTransform: 'none',
    height: 48,
    fontSize: 18,
    fontWeight: 'normal',
  }
};
